import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Thunk para obtener configuración del sistema
export const fetchConfig = createAsyncThunk(
  'config/fetchConfig',
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:3000/api'}/config`);
      
      if (!response.ok) {
        throw new Error('Error al obtener configuración');
      }
      
      const config = await response.json();
      return config;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState = {
  requireAccessCode: true, // Por defecto requiere código
  loading: false,
  error: null,
  isInitialized: false,
};

const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    clearConfigError: (state) => {
      state.error = null;
    },
    // Acción para marcar como inicializado manualmente si es necesario
    setInitialized: (state) => {
      state.isInitialized = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchConfig.pending, (state) => {
        state.loading = true;
        state.error = null;
        // No cambiar isInitialized aquí, mantener en false hasta que se complete
      })
      .addCase(fetchConfig.fulfilled, (state, action) => {
        state.loading = false;
        state.requireAccessCode = action.payload.requireAccessCode ?? true;
        state.error = null;
        state.isInitialized = true; // Marcar como inicializado solo cuando se completa exitosamente
      })
      .addCase(fetchConfig.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.isInitialized = true; // Marcar como inicializado incluso si hay error para evitar loop infinito
      });
  },
});

export const { clearConfigError, setInitialized } = configSlice.actions;
export default configSlice.reducer; 